import type { MouseEvent } from 'react'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import { SIZE } from 'baseui/input'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'

interface ForceFieldButtonProps {
  hidden: boolean
  buttonText: string
  onForce: () => void
  label?: string
}

const ForceFieldButton = ({ hidden, buttonText, onForce, label }: ForceFieldButtonProps) => {
  if (hidden) return null

  return (
    <SDFormControl plainLabel label={label}>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton
        size={SIZE.mini}
        block
        onClick={(event: MouseEvent) => {
          event.preventDefault()
          onForce()
        }}
      >
        {buttonText}
      </SDButton>
    </SDFormControl>
  )
}

export default ForceFieldButton
